import NewPayoff from './NewPayoff';

export default NewPayoff;
